namespace PlantDesign.UI {
    export const enum UserRoles {
        ApplicationAccess = 'ApplicationAccess',
    }
    export const enum UserNotificationSeverity {
        Info,
        Warning,
        Error,
    }
    // List of features handled by roles
    // For toggle features, go to toggleFeature.service.ts
    export const enum Feature {
        Inspect,
        Configure,
        Reports,
        Compare,
    }
}
namespace PlantDesign.API {
    export const enum AdvancedFilterType {
        Number = 'Number',
        Date = 'Date',
        Text = 'Text',
    }
    export const enum AdvancedFilterOperator {
        Equals = 'Equal',
        DoesNotEqual = 'DoesNotEqual',
        GreaterThanOrEqual = 'GreaterThanOrEqual',
        LessThanOrEqual = 'LessThanOrEqual',
        Contains = 'Contains',
        StartsWith = 'StartsWith',
        EndsWith = 'EndsWith',
        GreaterThan = 'Greater',
        LessThan = 'Less',
    }
    export enum EffectiveTurbulenceMode {
        IecQuantile = 2,
        LogNormalQuantile = 3,
    }
    export enum WakeTurbulenceMode {
        SteenFrandsen = 0,
        TNO = 2,
    }
    export enum TidOptions {
        MastDataScaling = 1,
        MastDataCfdScaling = 2,
        CalculatedFromIec = 3,
        Customer = 4,
        CustomerTimeSeries = 5,
        WakeGuard = 6,
        Wake2e = 7,
    }
    export enum WsdOptions {
        Wasp = 1,
        Cfd = 2,
        Customer = 3,
        CustomerTimeSeries = 4,
    }
    export enum LayoutMatchStatus {
        Clered = 'Cleared',
        Match = 'FullMatch',
        PropertyMismatch = 'PropertyMismatch',
        PositionMismatch = 'PositionMismatch',
        VDC = 'Vdc',
        UnFound = 'Unfound',
    }
    export enum MetStationType {
        MetMast = 0,
        RemoteSensing = 1,
        Virtual = 2,
        PPT = 3,
        SC = 4,
        TurbineLevelClimate = 5,
    }

}
